import HP from "../host";
import { ApiService } from "./API";
const api = new ApiService(`${HP.request}://${HP.host}/api/v1`);
const NotificationService = {
  getNotifications: async () => {
    return await api.get("/notification");
  },
  removeNotifications: async (id: string) => {
    return await api.delete(`/notification/${id}`);
  },
};
export default NotificationService;
